import { compose } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import {
    getFirstCheckedReservationServiceId,
    getFirstCheckedReservationAvailabilityBlockId,
    getCheckedReservationsHaveCommanderServiceOrderOrigin,
} from '../../selectors';
import withReservationsSameService from '../withReservationsSameService';

export default compose(
    connect(
        // @ts-expect-error $TSFixMeError: No overload matches this call.
        createStructuredSelector({
            serviceId: getFirstCheckedReservationServiceId,
            firstCheckedReservationAvailabilityBlockId: getFirstCheckedReservationAvailabilityBlockId,
            checkedReservationsHaveCommanderServiceOrderOrigin: getCheckedReservationsHaveCommanderServiceOrderOrigin,
        })
    ),
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    withReservationsSameService
);
